import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Avatar, Typography, Button, Menu, MenuItem, WithStyles, withStyles} from '@material-ui/core';
import {RootState} from '../../../reducers';
import {ProfileDto} from '../../../dto/ProfileDto';
import {clearUser} from 'feedback-system/auth/actions';
import {redirectToLoginPage} from 'feedback-system/utils';
import styles from './styles';

export interface OwnProps extends WithStyles<typeof styles> {
    profile: ProfileDto | null;
}

export interface State {
    anchorEl: HTMLElement | null;
}

interface Dispatch {
    clearUser: typeof clearUser;
}

type IProps = OwnProps & Dispatch;

class UserMenu extends Component<IProps, State> {
    state = {
        anchorEl: null
    };

    handleClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.setState({anchorEl: e.currentTarget});
    };

    handleClose = () => {
        this.setState({anchorEl: null});
    };

    logout = () => {
        if (localStorage.getItem('accessToken')) {
            this.props.clearUser();
            localStorage.removeItem('accessToken');
            localStorage.removeItem('projectId');
            redirectToLoginPage();
        }
    };

    render() {
        const {classes, profile} = this.props;
        const {anchorEl} = this.state;

        return (
            <div>
                {profile ? (
                    <Button onClick={this.handleClick} className={classes.btn}>
                        <Typography className={classes.userName} variant="body1">
                            {profile.firstName ? `${profile.firstName} ${profile.lastName}` : 'John Smith'}
                        </Typography>

                        {profile.avatarURL ? (
                            <Avatar
                                alt={`${profile.firstName} ${profile.lastName}`}
                                src={profile.avatarURL}
                                className={classes.avatar}
                            />
                        ) : (
                            <Avatar className={classes.avatar}>{profile.firstName.charAt(0)}</Avatar>
                        )}
                    </Button>
                ) : (
                    <Avatar className={classes.avatarPreloader}>&nbsp;</Avatar>
                )}
                <Menu
                    className={classes.menu}
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    transformOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    getContentAnchorEl={null}
                    onClose={this.handleClose}>
                    <MenuItem onClick={this.handleClose}>
                        <Link className={classes.link} to="/profile">
                            Profile
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={this.logout}>Logout</MenuItem>
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    profile: state.auth.profile
});

const mapDispatchToProps: Dispatch = {clearUser};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default withStyles(styles)(connector(UserMenu));
